/* AURA Smart Prefetch Engine 4.0 */
(() => {
  const config = {
    delay: 130,
    maxEntries: 40,
    maxConcurrent: 3,
    ttl: 1000 * 60 * 5
  };

  const cache = new Map();
  const controllers = new Map();
  const queue = [];
  const metrics = {
    requested: 0,
    completed: 0,
    aborted: 0,
    hits: 0,
    errors: 0
  };

  let active = 0;

  const isEligible = (url) => {
    try {
      const u = new URL(url, location.href);
      if (u.origin !== location.origin) return false;
      if (u.pathname.includes('/cart') || u.pathname.includes('/account') || u.pathname.includes('/checkout')) return false;
      return /^\/(products|collections|pages|blogs|search)/.test(u.pathname) || u.pathname === '/';
    } catch(e) {
      return false;
    }
  };

  const badge = (text) => {
    let el = document.querySelector('[data-aura-prefetch4-badge]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'aura-prefetch4__badge';
      el.setAttribute('data-aura-prefetch4-badge','');
      el.innerHTML = '<span class="aura-prefetch4__dot"></span><span data-text></span>';
      document.body.appendChild(el);
    }
    el.querySelector('[data-text]').textContent = text || 'Prefetch';
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-visible'), 900);
  };

  const prune = () => {
    if (cache.size <= config.maxEntries) return;
    const oldest = [...cache.entries()].sort((a,b) => a[1].time - b[1].time).slice(0, cache.size - config.maxEntries);
    oldest.forEach(([key]) => cache.delete(key));
  };

  const get = (url) => {
    const item = cache.get(url);
    if (!item) return null;
    if (Date.now() - item.time > config.ttl) {
      cache.delete(url);
      return null;
    }
    metrics.hits++;
    return item.html;
  };

  const runNext = () => {
    if (active >= config.maxConcurrent || !queue.length) return;
    const { url } = queue.shift();
    if (cache.has(url) || controllers.has(url)) return runNext();

    const controller = new AbortController();
    controllers.set(url, controller);
    active++;
    metrics.requested++;
    badge('Prefetch');

    fetch(url, {
      credentials: 'same-origin',
      signal: controller.signal,
      headers: { 'X-AURA-Prefetch': '1' }
    })
      .then(res => res.ok ? res.text() : Promise.reject(res.status))
      .then(html => {
        cache.set(url, { html, time: Date.now() });
        metrics.completed++;
        prune();
      })
      .catch(err => {
        if (String(err).includes('Abort')) metrics.aborted++;
        else metrics.errors++;
      })
      .finally(() => {
        active--;
        controllers.delete(url);
        runNext();
        window.dispatchEvent(new CustomEvent('aura:prefetch:metrics', { detail: metrics }));
      });
  };

  const prefetch = (url, priority = false) => {
    const normalized = new URL(url, location.href).href;
    if (!isEligible(normalized) || cache.has(normalized) || controllers.has(normalized)) return;
    priority ? queue.unshift({ url: normalized }) : queue.push({ url: normalized });
    runNext();
  };

  const abort = (url) => {
    try {
      const normalized = new URL(url, location.href).href;
      controllers.get(normalized)?.abort();
    } catch(e) {}
  };

  const bindLinks = (root = document) => {
    root.querySelectorAll('a[href]').forEach(link => {
      if (link.dataset.auraPrefetchBound) return;
      if (!isEligible(link.href)) return;
      link.dataset.auraPrefetchBound = 'true';

      let timer;
      link.addEventListener('mouseenter', () => {
        timer = setTimeout(() => prefetch(link.href), config.delay);
      }, { passive: true });

      link.addEventListener('mouseleave', () => {
        clearTimeout(timer);
      }, { passive: true });

      link.addEventListener('touchstart', () => prefetch(link.href, true), { passive: true });
      link.addEventListener('focus', () => prefetch(link.href), { passive: true });
    });
  };

  const prefetchNextPagination = () => {
    const next = document.querySelector('a[rel="next"], [data-next-url], .pagination a[href*="page="]');
    const url = next?.href || next?.dataset?.nextUrl;
    if (url) prefetch(url);
  };

  window.AuraPrefetch = { prefetch, get, abort, bindLinks, metrics, cache };

  const init = () => {
    document.body.classList.add('aura-prefetch4');
    bindLinks();
    window.AuraIdle?.add('prefetch-next-pagination', prefetchNextPagination);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();

  document.addEventListener('shopify:section:load', e => bindLinks(e.target));
})();
